// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-templates-page-jsx" + "-" + "07d52138844d96128149" + ".js";
};